// src/components/social-share-button/social-share-button.tsx
function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
  if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _async_to_generator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _iterable_to_array(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _to_consumable_array(arr) {
  return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
  var f,
    y,
    t,
    g,
    _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    };
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment IconFragment on Icon {\n    id\n    title\n    description\n    spotLight\n    size\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  fragment OverlayButtonFragment on EGDSOverlayButton {\n    primary\n    icon {\n      ...IconFragment\n    }\n  }\n  ", "\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _tagged_template_literal(["\n  fragment PrimaryButtonFragment on UIPrimaryButton {\n    primary\n    icon {\n      ...IconFragment\n    }\n  }\n  ", "\n"]);
  _templateObject2 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _tagged_template_literal(["\n  fragment SecondaryButtonFragment on UISecondaryButton {\n    primary\n    icon {\n      ...IconFragment\n    }\n  }\n  ", "\n"]);
  _templateObject3 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = _tagged_template_literal(["\n  fragment TertiaryButtonFragment on UITertiaryButton {\n    primary\n    icon {\n      ...IconFragment\n    }\n  }\n  ", "\n"]);
  _templateObject4 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject5() {
  var data = _tagged_template_literal(["\n  fragment ShareButtonTypesFragment on ShareButtonTypes {\n    ...OverlayButtonFragment\n    ...PrimaryButtonFragment\n    ...SecondaryButtonFragment\n    ...TertiaryButtonFragment\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject5 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject6() {
  var data = _tagged_template_literal(["\n  fragment SocialShareOptionButtonFragment on SocialMediaButton {\n    primary\n    socialMediaImage {\n      __typename\n      ... on Image {\n        url\n        description\n      }\n    }\n    socialMediaShareCustomAnalytics {\n      clickImpressionAnalytics {\n        linkName\n        referrerId\n      }\n      loadAnalytics {\n        linkName\n        referrerId\n      }\n    }\n    socialMediaShareLink {\n      text\n      icon {\n        ...IconFragment\n      }\n      action {\n        target\n        resource {\n          value\n        }\n      }\n    }\n  }\n  ", "\n"]);
  _templateObject6 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject7() {
  var data = _tagged_template_literal(["\n  fragment ToolbarFragment on EGDSToolbar {\n    actions {\n      ...OverlayButtonFragment\n    }\n    navigation {\n      analytics {\n        linkName\n        referrerId\n      }\n    }\n  }\n  ", "\n"]);
  _templateObject7 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject8() {
  var data = _tagged_template_literal(["\n  fragment ParagraphFragment on EGDSParagraph {\n    text\n    style\n  }\n"]);
  _templateObject8 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject9() {
  var data = _tagged_template_literal(["\n  fragment PlainTextFragment on EGDSPlainText {\n    text\n  }\n"]);
  _templateObject9 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject10() {
  var data = _tagged_template_literal(["\n  fragment TextFragment on EGDSText {\n    ...ParagraphFragment\n    ...PlainTextFragment\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject10 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject11() {
  var data = _tagged_template_literal(["\n  fragment CardFragment on EGDSImageCard {\n    image {\n      url\n      description\n    }\n    id\n    title\n    subTitle\n    description\n  }\n"]);
  _templateObject11 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject12() {
  var data = _tagged_template_literal(["\n  fragment SocialShareErrorFragment on SocialShareErrorBanner {\n    heading\n    description\n    theme\n    errorAnalytics {\n      referrerId\n      linkName\n    }\n  }\n  ", "\n"]);
  _templateObject12 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject13() {
  var data = _tagged_template_literal(["\n  fragment ShareSheetAnalyticsFragment on SocialShareCustomAnalytics {\n    loadAnalytics {\n      linkName\n      referrerId\n    }\n    outcomeAnalytics {\n      linkName\n      referrerId\n    }\n  }\n\n  fragment EGDSStandardLinkFragment on EGDSStandardLink {\n    action {\n      resource {\n        value\n      }\n      target\n    }\n  }\n\n  fragment MessageFragment on EGDSSpannableText {\n    text\n    inlineContent {\n      ...PlainTextFragment\n      ...EGDSStandardLinkFragment\n    }\n  }\n\n  query SocialShareButtonQuery($context: ContextInput!, $shareContext: ShareContextInput!) {\n    socialShareSheet(context: $context, shareContextInput: $shareContext) {\n      title\n      message {\n        ...MessageFragment\n      }\n      shareButtonType {\n        ...ShareButtonTypesFragment\n      }\n      shareButtonAnalytics {\n        loadAnalytics {\n          referrerId\n          linkName\n        }\n        clickImpressionAnalytics {\n          linkName\n          referrerId\n        }\n      }\n      imageCard {\n        ...CardFragment\n      }\n      socialMediaButtonsForShareSheet {\n        ...SocialShareOptionButtonFragment\n      }\n      toolbar {\n        ...ToolbarFragment\n      }\n      shareSheetAnalytics {\n        ...ShareSheetAnalyticsFragment\n      }\n      clientSideErrorDialog {\n        ...SocialShareErrorFragment\n      }\n      serverSideErrorDialog {\n        ...SocialShareErrorFragment\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject13 = function _templateObject() {
    return data;
  };
  return data;
}
import React18 from "react";
import { useLocation } from "react-router-dom";
import { gql as gql14, useLazyQuery } from "@apollo/client";
import { UitkPageLoader } from "@egds/react-core/loader";
import { useBexApi } from "@shared-ui/bex-api-context";
import { IntersectionTracker as IntersectionTracker3, useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";
import { useDialog } from "@shared-ui/dialog-context";
import { useExperiment } from "@shared-ui/experiment-context";
// ../internal/src/components/button/share-buttons.tsx
import React6 from "react";
import { gql as gql6 } from "@apollo/client";
// ../internal/src/components/button/overlay-button.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { UitkOverlayButton } from "@egds/react-core/button";
import { EGDSText } from "@egds/react-core/text";
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
// ../internal/src/components/icon/icon.tsx
import React from "react";
import { gql } from "@apollo/client";
import { EGDSIcon, EGDSIconSize } from "@egds/react-core/icons";
// ../internal/src/__generated__/types.ts
var IconSpotLight = /* @__PURE__ */function (IconSpotLight2) {
  IconSpotLight2["INFO"] = "INFO";
  IconSpotLight2["POSITIVE"] = "POSITIVE";
  IconSpotLight2["STANDARD"] = "STANDARD";
  IconSpotLight2["WARNING"] = "WARNING";
  return IconSpotLight2;
}(IconSpotLight || {});
// ../internal/src/components/icon/icon.tsx
var __IconFragment = gql(_templateObject());
var Icon = function (param) {
  var data = param.data,
    className = param.className;
  var _IconSpotLight__toLowerCase, _IconSpotLight_;
  var _data_id, _data_title, _data_spotLight;
  return /* @__PURE__ */React.createElement(EGDSIcon, {
    id: data === null || data === void 0 ? void 0 : data.id,
    name: (_data_id = data === null || data === void 0 ? void 0 : data.id) !== null && _data_id !== void 0 ? _data_id : "error",
    title: (_data_title = data === null || data === void 0 ? void 0 : data.title) !== null && _data_title !== void 0 ? _data_title : "Share button",
    description: data === null || data === void 0 ? void 0 : data.description,
    className: className,
    size: EGDSIconSize.SMALL,
    spotlight: (_IconSpotLight_ = IconSpotLight[(_data_spotLight = data === null || data === void 0 ? void 0 : data.spotLight) !== null && _data_spotLight !== void 0 ? _data_spotLight : "none"]) === null || _IconSpotLight_ === void 0 ? void 0 : (_IconSpotLight__toLowerCase = _IconSpotLight_.toLowerCase) === null || _IconSpotLight__toLowerCase === void 0 ? void 0 : _IconSpotLight__toLowerCase.call(_IconSpotLight_)
  });
};
Icon.fragment = __IconFragment;
Icon.displayName = "UitkIcon";
// ../internal/src/components/button/overlay-button.tsx
var __OverlayButtonFragment = gql2(_templateObject1(), Icon.fragment);
var OverlayButton = function (param) {
  var data = param.data,
    domRef = param.domRef,
    onClick = param.onClick;
  if (!(data === null || data === void 0 ? void 0 : data.icon)) {
    return null;
  }
  var icon = data.icon;
  return /* @__PURE__ */React2.createElement(Viewport, null, /* @__PURE__ */React2.createElement(ViewSmall, null, /* @__PURE__ */React2.createElement(UitkOverlayButton, {
    onClick: onClick,
    domRef: domRef
  }, /* @__PURE__ */React2.createElement(Icon, {
    data: icon
  }))), /* @__PURE__ */React2.createElement(ViewMedium, null, /* @__PURE__ */React2.createElement(UitkOverlayButton, {
    onClick: onClick,
    domRef: domRef
  }, /* @__PURE__ */React2.createElement(Icon, {
    data: icon
  }), data.primary && /* @__PURE__ */React2.createElement(EGDSText, {
    theme: "inverse"
  }, data.primary))));
};
OverlayButton.fragment = __OverlayButtonFragment;
OverlayButton.displayName = "OverlayButton";
// ../internal/src/components/button/primary-button.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { UitkPrimaryButton } from "@egds/react-core/button";
import { EGDSText as EGDSText2 } from "@egds/react-core/text";
import { ViewMedium as ViewMedium2, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
var __PrimaryButtonFragment = gql3(_templateObject2(), Icon.fragment);
var PrimaryButton = function (param) {
  var data = param.data,
    domRef = param.domRef,
    onClick = param.onClick;
  if (!(data === null || data === void 0 ? void 0 : data.icon)) {
    return null;
  }
  var icon = data.icon;
  return /* @__PURE__ */React3.createElement(Viewport2, null, /* @__PURE__ */React3.createElement(ViewSmall2, null, /* @__PURE__ */React3.createElement(UitkPrimaryButton, {
    onClick: onClick,
    domRef: domRef
  }, /* @__PURE__ */React3.createElement(Icon, {
    data: icon
  }))), /* @__PURE__ */React3.createElement(ViewMedium2, null, /* @__PURE__ */React3.createElement(UitkPrimaryButton, {
    onClick: onClick,
    domRef: domRef
  }, /* @__PURE__ */React3.createElement(Icon, {
    data: icon
  }), data.primary && /* @__PURE__ */React3.createElement(EGDSText2, {
    theme: "inverse"
  }, data.primary))));
};
PrimaryButton.fragment = __PrimaryButtonFragment;
PrimaryButton.displayName = "PrimaryButton";
// ../internal/src/components/button/secondary-button.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
import { EGDSButtonSize, EGDSFloatingButton } from "@egds/react-core/button";
import { EGDSText as EGDSText3 } from "@egds/react-core/text";
import { ViewMedium as ViewMedium3, Viewport as Viewport3, ViewSmall as ViewSmall3 } from "@shared-ui/viewport-context";
var __SecondaryButtonFragment = gql4(_templateObject3(), Icon.fragment);
var SecondaryButton = function (param) {
  var data = param.data,
    domRef = param.domRef,
    onClick = param.onClick;
  if (!(data === null || data === void 0 ? void 0 : data.icon)) {
    return null;
  }
  var icon = data.icon;
  return /* @__PURE__ */React4.createElement(Viewport3, null, /* @__PURE__ */React4.createElement(ViewSmall3, null, /* @__PURE__ */React4.createElement(EGDSFloatingButton, {
    onClick: onClick,
    size: EGDSButtonSize.SMALL,
    domRef: domRef
  }, /* @__PURE__ */React4.createElement(Icon, {
    data: icon
  }))), /* @__PURE__ */React4.createElement(ViewMedium3, null, /* @__PURE__ */React4.createElement(EGDSFloatingButton, {
    onClick: onClick,
    size: EGDSButtonSize.SMALL,
    domRef: domRef
  }, /* @__PURE__ */React4.createElement(Icon, {
    data: icon
  }), data.primary && /* @__PURE__ */React4.createElement(EGDSText3, null, data.primary))));
};
SecondaryButton.fragment = __SecondaryButtonFragment;
SecondaryButton.displayName = "SecondaryButton";
// ../internal/src/components/button/tertiary-button.tsx
import React5 from "react";
import { gql as gql5 } from "@apollo/client";
import { UitkTertiaryButton } from "@egds/react-core/button";
import { EGDSText as EGDSText4 } from "@egds/react-core/text";
import { ViewMedium as ViewMedium4, Viewport as Viewport4, ViewSmall as ViewSmall4 } from "@shared-ui/viewport-context";
var __TertiaryButtonFragment = gql5(_templateObject4(), Icon.fragment);
var TertiaryButton = function (param) {
  var data = param.data,
    domRef = param.domRef,
    onClick = param.onClick;
  if (!(data === null || data === void 0 ? void 0 : data.icon)) {
    return null;
  }
  var icon = data.icon;
  return /* @__PURE__ */React5.createElement(Viewport4, null, /* @__PURE__ */React5.createElement(ViewSmall4, null, /* @__PURE__ */React5.createElement(UitkTertiaryButton, {
    onClick: onClick,
    domRef: domRef
  }, /* @__PURE__ */React5.createElement(Icon, {
    data: icon
  }))), /* @__PURE__ */React5.createElement(ViewMedium4, null, /* @__PURE__ */React5.createElement(UitkTertiaryButton, {
    onClick: onClick,
    domRef: domRef
  }, /* @__PURE__ */React5.createElement(Icon, {
    data: icon
  }), data.primary && /* @__PURE__ */React5.createElement(EGDSText4, null, data.primary))));
};
TertiaryButton.fragment = __TertiaryButtonFragment;
TertiaryButton.displayName = "TertiaryButton";
// ../internal/src/components/button/share-buttons.tsx
var fragment = gql6(_templateObject5(), PrimaryButton.fragment, SecondaryButton.fragment, TertiaryButton.fragment, OverlayButton.fragment);
var ShareButtons = function (param) {
  var data = param.data,
    domRef = param.domRef,
    onClick = param.onClick;
  switch (data.__typename) {
    case "UIPrimaryButton":
      return /* @__PURE__ */React6.createElement(PrimaryButton, {
        data: data,
        onClick: onClick,
        domRef: domRef
      });
    case "UISecondaryButton":
      return /* @__PURE__ */React6.createElement(SecondaryButton, {
        data: data,
        onClick: onClick,
        domRef: domRef
      });
    case "UITertiaryButton":
      return /* @__PURE__ */React6.createElement(TertiaryButton, {
        data: data,
        onClick: onClick,
        domRef: domRef
      });
    case "EGDSOverlayButton":
      return /* @__PURE__ */React6.createElement(OverlayButton, {
        data: data,
        onClick: onClick,
        domRef: domRef
      });
    default:
      return null;
  }
};
ShareButtons.fragment = fragment;
ShareButtons.displayName = "ShareButton";
// ../internal/src/components/button/social-share-option-button.tsx
import React7 from "react";
import { gql as gql7 } from "@apollo/client";
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSLink } from "@egds/react-core/link";
import { EGDSMark } from "@egds/react-core/mark";
import { EGDSText as EGDSText5 } from "@egds/react-core/text";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
var __SocialShareOptionButtonFragment = gql7(_templateObject6(), Icon.fragment);
var SocialShareOptionButton = function (param) {
  var data = param.data,
    title = param.title,
    className = param.className,
    setToastText = param.setToastText;
  var analyticsTracker = useClickTracker();
  var primary = data.primary,
    socialMediaImage = data.socialMediaImage,
    socialMediaShareCustomAnalytics = data.socialMediaShareCustomAnalytics,
    socialMediaShareLink = data.socialMediaShareLink;
  var action = socialMediaShareLink.action,
    icon = socialMediaShareLink.icon;
  var handleAction = function () {
    var _ref = _async_to_generator(function () {
      var _socialMediaShareCustomAnalytics_clickImpressionAnalytics, _socialMediaShareCustomAnalytics_clickImpressionAnalytics1, _action_resource, popupFeatures;
      return _ts_generator(this, function (_state) {
        switch (_state.label) {
          case 0:
            if (socialMediaShareCustomAnalytics === null || socialMediaShareCustomAnalytics === void 0 ? void 0 : socialMediaShareCustomAnalytics.clickImpressionAnalytics) {
              ;
              analyticsTracker(socialMediaShareCustomAnalytics === null || socialMediaShareCustomAnalytics === void 0 ? void 0 : (_socialMediaShareCustomAnalytics_clickImpressionAnalytics = socialMediaShareCustomAnalytics.clickImpressionAnalytics) === null || _socialMediaShareCustomAnalytics_clickImpressionAnalytics === void 0 ? void 0 : _socialMediaShareCustomAnalytics_clickImpressionAnalytics.referrerId, socialMediaShareCustomAnalytics === null || socialMediaShareCustomAnalytics === void 0 ? void 0 : (_socialMediaShareCustomAnalytics_clickImpressionAnalytics1 = socialMediaShareCustomAnalytics.clickImpressionAnalytics) === null || _socialMediaShareCustomAnalytics_clickImpressionAnalytics1 === void 0 ? void 0 : _socialMediaShareCustomAnalytics_clickImpressionAnalytics1.linkName);
            }
            if (!(icon && action.resource.__typename !== "MailToURI")) return [3, 2];
            return [4, navigator.clipboard.writeText("".concat(title, " ").concat(action === null || action === void 0 ? void 0 : (_action_resource = action.resource) === null || _action_resource === void 0 ? void 0 : _action_resource.value))];
          case 1:
            _state.sent();
            setToastText(icon.description);
            return [2];
          case 2:
            if (primary === "Facebook" || primary === "Messenger") {
              popupFeatures = "width=900,height=550";
              window.open(action.resource.value, "", popupFeatures);
              return [2];
            }
            window.open(action.resource.value, "_blank");
            return [2];
        }
      });
    });
    return function handleAction() {
      return _ref.apply(this, arguments);
    };
  }();
  return /* @__PURE__ */React7.createElement(EGDSLink, {
    className: className,
    onClick: handleAction,
    align: "center"
  }, /* @__PURE__ */React7.createElement("button", {
    type: "button"
  }, /* @__PURE__ */React7.createElement(EGDSLayoutFlex, {
    direction: "column",
    justifyContent: "center",
    alignContent: "center",
    wrap: "wrap",
    space: "two"
  }, /* @__PURE__ */React7.createElement(EGDSLayoutFlexItem, {
    alignSelf: "center"
  }, icon !== null ? /* @__PURE__ */React7.createElement("div", null, /* @__PURE__ */React7.createElement(Icon, {
    data: icon
  })) : /* @__PURE__ */React7.createElement(EGDSMark, {
    url: socialMediaImage === null || socialMediaImage === void 0 ? void 0 : socialMediaImage.url,
    description: socialMediaImage === null || socialMediaImage === void 0 ? void 0 : socialMediaImage.description,
    size: 12
  })), /* @__PURE__ */React7.createElement(EGDSLayoutFlexItem, {
    alignSelf: "center"
  }, /* @__PURE__ */React7.createElement(EGDSText5, {
    weight: "bold",
    overflow: "truncate-2-lines"
  }, primary)))));
};
SocialShareOptionButton.fragment = __SocialShareOptionButtonFragment;
SocialShareOptionButton.displayName = "SocialShareOptionButton";
// ../internal/src/components/button/social-share-option-button-skeleton.tsx
import React8 from "react";
import { EGDSFigure, EGDSFigureAspectRatioType } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex2, EGDSLayoutFlexItem as EGDSLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { EGDSBlockSkeleton, EGDSLineSkeleton } from "@egds/react-core/skeleton";
var SocialShareOptionButtonSkeleton = function () {
  return /* @__PURE__ */React8.createElement(EGDSLayoutFlex2, {
    direction: "column",
    justifyContent: "center",
    space: "two"
  }, /* @__PURE__ */React8.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React8.createElement(EGDSFigure, {
    ratio: EGDSFigureAspectRatioType.R3_2
  }, /* @__PURE__ */React8.createElement(EGDSBlockSkeleton, {
    type: "rounded"
  })), /* @__PURE__ */React8.createElement(EGDSLineSkeleton, null)), /* @__PURE__ */React8.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React8.createElement(EGDSLineSkeleton, null)));
};
// ../internal/src/components/toolbar/toolbar.tsx
import React9 from "react";
import { gql as gql8 } from "@apollo/client";
import { EGDSToolbar } from "@egds/react-core/toolbar";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
var __ToolBarFragment = gql8(_templateObject7(), OverlayButton.fragment);
var Toolbar = function (param) {
  var data = param.data,
    onDismissSheet = param.onDismissSheet;
  var analyticsTracker = useClickTracker2();
  if (!data) {
    return null;
  }
  return /* @__PURE__ */React9.createElement(EGDSToolbar, {
    navigationContent: {
      onClick: function () {
        var _data_navigation_analytics, _data_navigation_analytics1;
        var _data_navigation_analytics_referrerId, _data_navigation_analytics_linkName;
        analyticsTracker((_data_navigation_analytics_referrerId = (_data_navigation_analytics = data.navigation.analytics) === null || _data_navigation_analytics === void 0 ? void 0 : _data_navigation_analytics.referrerId) !== null && _data_navigation_analytics_referrerId !== void 0 ? _data_navigation_analytics_referrerId : "", (_data_navigation_analytics_linkName = (_data_navigation_analytics1 = data.navigation.analytics) === null || _data_navigation_analytics1 === void 0 ? void 0 : _data_navigation_analytics1.linkName) !== null && _data_navigation_analytics_linkName !== void 0 ? _data_navigation_analytics_linkName : "");
        onDismissSheet === null || onDismissSheet === void 0 ? void 0 : onDismissSheet();
      },
      navIconLabel: "Close Toolbar"
    }
  });
};
Toolbar.fragment = __ToolBarFragment;
Toolbar.displayName = "EGDSToolbar";
// ../internal/src/components/text/text.tsx
import React12 from "react";
import { gql as gql11 } from "@apollo/client";
// ../internal/src/components/text/paragraph.tsx
import React10 from "react";
import { gql as gql9 } from "@apollo/client";
import { EGDSParagraph } from "@egds/react-core/text";
var fragment2 = gql9(_templateObject8());
var _obj;
var EGDSParagraphSizeMap = (_obj = {}, _define_property(_obj, "P1" /* P1 */, 1), _define_property(_obj, "P2" /* P2 */, 2), _define_property(_obj, "P3" /* P3 */, 3), _obj);
var Paragraph = function (param) {
  var data = param.data;
  return /* @__PURE__ */React10.createElement(EGDSParagraph, {
    size: EGDSParagraphSizeMap[data.style]
  }, data.text);
};
Paragraph.fragment = fragment2;
Paragraph.displayName = "Paragraph";
// ../internal/src/components/text/plain-text.tsx
import React11 from "react";
import { gql as gql10 } from "@apollo/client";
import { EGDSText as EGDSText6 } from "@egds/react-core/text";
var fragment3 = gql10(_templateObject9());
var PlainText = function (param) {
  var data = param.data;
  return /* @__PURE__ */React11.createElement(EGDSText6, null, data.text);
};
PlainText.fragment = fragment3;
PlainText.displayName = "PlainText";
// ../internal/src/components/text/text.tsx
var fragment4 = gql11(_templateObject10(), Paragraph.fragment, PlainText.fragment);
var Text = function (param) {
  var data = param.data;
  switch (data.__typename) {
    case "EGDSParagraph":
      return /* @__PURE__ */React12.createElement(Paragraph, {
        data: data
      });
    case "EGDSPlainText":
      return /* @__PURE__ */React12.createElement(PlainText, {
        data: data
      });
    default:
      return null;
  }
};
Text.fragment = fragment4;
Text.displayName = "Text";
// ../internal/src/components/card/card.tsx
import React13 from "react";
import { gql as gql12 } from "@apollo/client";
import { EGDSCardContentSection, UitkCard, UitkCardContentSection } from "@egds/react-core/cards";
import { UitkFigure, UitkFigureAspectRatioType, UitkImage } from "@egds/react-core/images";
import { EGDSLayoutGrid, EGDSLayoutGridItem } from "@egds/react-core/layout-grid";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { EGDSText as EGDSText7 } from "@egds/react-core/text";
import { ViewLarge, Viewport as Viewport5, ViewSmall as ViewSmall5 } from "@shared-ui/viewport-context";
var fragment5 = gql12(_templateObject11());
var Card = function (param) {
  var data = param.data;
  var _data_image, _data_image1, _data_image2, _data_image3;
  return /* @__PURE__ */React13.createElement(Viewport5, null, /* @__PURE__ */React13.createElement(ViewSmall5, null, /* @__PURE__ */React13.createElement(UitkCard, {
    border: true
  }, /* @__PURE__ */React13.createElement(UitkFigure, {
    ratio: UitkFigureAspectRatioType.R16_9
  }, /* @__PURE__ */React13.createElement(UitkImage, {
    placeholderImage: true,
    alt: data === null || data === void 0 ? void 0 : (_data_image = data.image) === null || _data_image === void 0 ? void 0 : _data_image.description,
    src: data === null || data === void 0 ? void 0 : (_data_image1 = data.image) === null || _data_image1 === void 0 ? void 0 : _data_image1.url
  })), /* @__PURE__ */React13.createElement(UitkCardContentSection, null, /* @__PURE__ */React13.createElement(EGDSText7, {
    size: 500,
    weight: "bold"
  }, data.title), /* @__PURE__ */React13.createElement(EGDSText7, {
    size: 300
  }, data.subTitle), /* @__PURE__ */React13.createElement(EGDSText7, {
    size: 300
  }, data.description)))), /* @__PURE__ */React13.createElement(ViewLarge, null, /* @__PURE__ */React13.createElement(UitkCard, {
    border: true
  }, /* @__PURE__ */React13.createElement(EGDSLayoutGrid, {
    columns: 5
  }, /* @__PURE__ */React13.createElement(EGDSLayoutGridItem, {
    colSpan: 2
  }, /* @__PURE__ */React13.createElement(UitkFigure, {
    ratio: UitkFigureAspectRatioType.R16_9
  }, /* @__PURE__ */React13.createElement(UitkImage, {
    placeholderImage: true,
    alt: data === null || data === void 0 ? void 0 : (_data_image2 = data.image) === null || _data_image2 === void 0 ? void 0 : _data_image2.description,
    src: data === null || data === void 0 ? void 0 : (_data_image3 = data.image) === null || _data_image3 === void 0 ? void 0 : _data_image3.url
  }))), /* @__PURE__ */React13.createElement(EGDSLayoutGridItem, {
    colSpan: 3
  }, /* @__PURE__ */React13.createElement(EGDSCardContentSection, {
    padded: true
  }, /* @__PURE__ */React13.createElement(EGDSText7, {
    size: 500,
    weight: "bold"
  }, data.title), /* @__PURE__ */React13.createElement(EGDSSpacing, {
    margin: {
      block: "one"
    }
  }, /* @__PURE__ */React13.createElement(EGDSText7, {
    size: 300
  }, data.subTitle)), /* @__PURE__ */React13.createElement(EGDSSpacing, {
    margin: {
      blockend: "four"
    }
  }, /* @__PURE__ */React13.createElement(EGDSText7, {
    size: 300
  }, data.description))))))));
};
Card.fragment = fragment5;
Card.displayName = "Card";
// ../internal/src/components/card/card-skeleton.tsx
import React14 from "react";
import { EGDSFigure as EGDSFigure2, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType2 } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex3, EGDSLayoutFlexItem as EGDSLayoutFlexItem3 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid2, EGDSLayoutGridItem as EGDSLayoutGridItem2 } from "@egds/react-core/layout-grid";
import { EGDSBlockSkeleton as EGDSBlockSkeleton2, EGDSLineSkeleton as EGDSLineSkeleton2 } from "@egds/react-core/skeleton";
var CardSkeleton = function () {
  return /* @__PURE__ */React14.createElement(EGDSLayoutGrid2, {
    columns: 5,
    space: {
      column: "four"
    }
  }, /* @__PURE__ */React14.createElement(EGDSLayoutGridItem2, {
    colSpan: 2
  }, /* @__PURE__ */React14.createElement(EGDSFigure2, {
    ratio: EGDSFigureAspectRatioType2.R16_9
  }, /* @__PURE__ */React14.createElement(EGDSBlockSkeleton2, {
    type: "rounded"
  }))), /* @__PURE__ */React14.createElement(EGDSLayoutGridItem2, {
    colSpan: 2
  }, /* @__PURE__ */React14.createElement(EGDSLayoutFlex3, {
    direction: "column",
    justifyContent: "space-around"
  }, /* @__PURE__ */React14.createElement(EGDSLayoutFlexItem3, null, /* @__PURE__ */React14.createElement(EGDSLineSkeleton2, null)), /* @__PURE__ */React14.createElement(EGDSLayoutFlexItem3, null, /* @__PURE__ */React14.createElement(EGDSLineSkeleton2, {
    type: "secondary"
  })), /* @__PURE__ */React14.createElement(EGDSLayoutFlexItem3, null, /* @__PURE__ */React14.createElement(EGDSLineSkeleton2, {
    type: "secondary"
  })))));
};
// src/components/social-share-button/social-share-button.tsx
import { ViewLarge as ViewLarge3, Viewport as Viewport7, ViewSmall as ViewSmall7 } from "@shared-ui/viewport-context";
// src/__generated__/types.ts
var AppGrowthLineOfBusiness = /* @__PURE__ */function (AppGrowthLineOfBusiness2) {
  AppGrowthLineOfBusiness2["ACTIVITIES"] = "ACTIVITIES";
  AppGrowthLineOfBusiness2["CAR"] = "CAR";
  AppGrowthLineOfBusiness2["CRUISES"] = "CRUISES";
  AppGrowthLineOfBusiness2["DEFAULT"] = "DEFAULT";
  AppGrowthLineOfBusiness2["FLIGHT"] = "FLIGHT";
  AppGrowthLineOfBusiness2["GROUNDTRANSFERS"] = "GROUNDTRANSFERS";
  AppGrowthLineOfBusiness2["HOTEL"] = "HOTEL";
  AppGrowthLineOfBusiness2["PACKAGES"] = "PACKAGES";
  AppGrowthLineOfBusiness2["RAILS"] = "RAILS";
  AppGrowthLineOfBusiness2["UNCLASSIFIED"] = "UNCLASSIFIED";
  return AppGrowthLineOfBusiness2;
}(AppGrowthLineOfBusiness || {});
// src/components/utils/get-page-id.ts
var getPageId = function (xPageId) {
  var identifiers = xPageId === null || xPageId === void 0 ? void 0 : xPageId.split(",").map(function (identifier) {
    return identifier.trim();
  });
  var _identifiers_;
  return {
    pageId: identifiers === null || identifiers === void 0 ? void 0 : identifiers[0],
    lineOfBusiness: AppGrowthLineOfBusiness[(_identifiers_ = identifiers === null || identifiers === void 0 ? void 0 : identifiers[1]) !== null && _identifiers_ !== void 0 ? _identifiers_ : ""] || "UNCLASSIFIED" /* UNCLASSIFIED */
  };
};
// src/components/native-social-share-sheet/native-social-share-sheet.tsx
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
var NativeSocialShareSheet = function (param) {
  var title = param.title,
    message = param.message,
    shareSheetAnalytics = param.shareSheetAnalytics,
    closeAnalytics = param.closeAnalytics,
    isClientSideError = param.isClientSideError,
    onChangeState = param.onChangeState,
    setIsClientSideError = param.setIsClientSideError;
  var _message_inlineContent_find_action, _message_inlineContent_find, _message_inlineContent, _message_inlineContent_find1, _message_inlineContent1, _navigator_canShare, _navigator;
  var analyticsTracker = useClickTracker3();
  if (!title || !shareSheetAnalytics || !closeAnalytics) {
    if (!isClientSideError) {
      setIsClientSideError(true);
    }
    return null;
  }
  var url = message === null || message === void 0 ? void 0 : (_message_inlineContent = message.inlineContent) === null || _message_inlineContent === void 0 ? void 0 : (_message_inlineContent_find = _message_inlineContent.find(function (content) {
    return (content === null || content === void 0 ? void 0 : content.__typename) === "EGDSStandardLink";
  })) === null || _message_inlineContent_find === void 0 ? void 0 : (_message_inlineContent_find_action = _message_inlineContent_find.action) === null || _message_inlineContent_find_action === void 0 ? void 0 : _message_inlineContent_find_action.resource.value;
  var _message_inlineContent_find_text;
  var text = (_message_inlineContent_find_text = message === null || message === void 0 ? void 0 : (_message_inlineContent1 = message.inlineContent) === null || _message_inlineContent1 === void 0 ? void 0 : (_message_inlineContent_find1 = _message_inlineContent1.find(function (content) {
    return (content === null || content === void 0 ? void 0 : content.__typename) === "EGDSPlainText";
  })) === null || _message_inlineContent_find1 === void 0 ? void 0 : _message_inlineContent_find1.text) !== null && _message_inlineContent_find_text !== void 0 ? _message_inlineContent_find_text : message === null || message === void 0 ? void 0 : message.text;
  var shareData = {
    title: title,
    text: text,
    url: url
  };
  var isNativeShareEnabled = (_navigator_canShare = (_navigator = navigator).canShare) === null || _navigator_canShare === void 0 ? void 0 : _navigator_canShare.call(_navigator, shareData);
  if (!isNativeShareEnabled) {
    return null;
  }
  navigator.share(shareData).then(function () {
    if (shareSheetAnalytics === null || shareSheetAnalytics === void 0 ? void 0 : shareSheetAnalytics.outcomeAnalytics) {
      var outcomeAnalytics = shareSheetAnalytics.outcomeAnalytics;
      analyticsTracker(outcomeAnalytics.referrerId, outcomeAnalytics.linkName);
    }
  }).catch(function (navigatorError) {
    if (navigatorError.name === "AbortError") {
      analyticsTracker(closeAnalytics.referrerId, closeAnalytics.linkName);
    }
  }).finally(function () {
    onChangeState(false);
  });
  return null;
};
NativeSocialShareSheet.displayName = "NativeSocialShareSheet";
// src/components/social-share-custom-sheet/social-share-custom-sheet.tsx
import React15 from "react";
import { EGDSLayoutGrid as EGDSLayoutGrid3, EGDSLayoutGridItem as EGDSLayoutGridItem3 } from "@egds/react-core/layout-grid";
import { EGDSScrollable } from "@egds/react-core/scrollable";
import { EGDSSheet, EGDSSheetContent, EGDSSheetTransition } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
import { EGDSToast } from "@egds/react-core/toast";
import { IntersectionTracker } from "@shared-ui/clickstream-analytics-context";
import { ViewLarge as ViewLarge2, Viewport as Viewport6, ViewSmall as ViewSmall6 } from "@shared-ui/viewport-context";
var CustomShareSheet = function (param) {
  var title = param.title,
    cardData = param.cardData,
    socialMediaButtonsForShareSheet = param.socialMediaButtonsForShareSheet,
    toolbarData = param.toolbarData,
    triggerRef2 = param.triggerRef,
    showShareSheet = param.showShareSheet,
    shareSheetAnalytics = param.shareSheetAnalytics,
    DialogComponent = param.DialogComponent,
    setIsClientSideError = param.setIsClientSideError,
    onDismissSheet = param.onDismissSheet;
  var _shareSheetAnalytics_loadAnalytics, _shareSheetAnalytics_loadAnalytics1, _shareSheetAnalytics_loadAnalytics2, _shareSheetAnalytics_loadAnalytics3;
  var _React15_useState = _sliced_to_array(React15.useState(""), 2),
    toastText = _React15_useState[0],
    setToastText = _React15_useState[1];
  if (!toolbarData) {
    setIsClientSideError(true);
  }
  var onToastDismiss = function () {
    setToastText(null);
  };
  var _shareSheetAnalytics_loadAnalytics_referrerId, _shareSheetAnalytics_loadAnalytics_linkName, _shareSheetAnalytics_loadAnalytics_referrerId1, _shareSheetAnalytics_loadAnalytics_linkName1;
  return /* @__PURE__ */React15.createElement(Viewport6, null, /* @__PURE__ */React15.createElement(ViewSmall6, null, /* @__PURE__ */React15.createElement(IntersectionTracker, {
    referrerId: (_shareSheetAnalytics_loadAnalytics_referrerId = shareSheetAnalytics === null || shareSheetAnalytics === void 0 ? void 0 : (_shareSheetAnalytics_loadAnalytics = shareSheetAnalytics.loadAnalytics) === null || _shareSheetAnalytics_loadAnalytics === void 0 ? void 0 : _shareSheetAnalytics_loadAnalytics.referrerId) !== null && _shareSheetAnalytics_loadAnalytics_referrerId !== void 0 ? _shareSheetAnalytics_loadAnalytics_referrerId : "",
    linkName: (_shareSheetAnalytics_loadAnalytics_linkName = shareSheetAnalytics === null || shareSheetAnalytics === void 0 ? void 0 : (_shareSheetAnalytics_loadAnalytics1 = shareSheetAnalytics.loadAnalytics) === null || _shareSheetAnalytics_loadAnalytics1 === void 0 ? void 0 : _shareSheetAnalytics_loadAnalytics1.linkName) !== null && _shareSheetAnalytics_loadAnalytics_linkName !== void 0 ? _shareSheetAnalytics_loadAnalytics_linkName : ""
  }, /* @__PURE__ */React15.createElement(EGDSSheetTransition, {
    isVisible: showShareSheet
  }, /* @__PURE__ */React15.createElement(DialogComponent, null, /* @__PURE__ */React15.createElement(EGDSSheet, {
    isVisible: showShareSheet,
    type: "bottom",
    triggerRef: triggerRef2,
    hasModal: true,
    closeCallback: onDismissSheet
  }, /* @__PURE__ */React15.createElement(Toolbar, {
    data: toolbarData,
    onDismissSheet: onDismissSheet
  }), /* @__PURE__ */React15.createElement(EGDSSheetContent, {
    padded: true
  }, cardData && /* @__PURE__ */React15.createElement(Card, {
    data: cardData
  }), /* @__PURE__ */React15.createElement(EGDSSpacing2, {
    margin: {
      blockstart: "four"
    }
  }, /* @__PURE__ */React15.createElement(EGDSScrollable, {
    direction: "horizontal"
  }, socialMediaButtonsForShareSheet === null || socialMediaButtonsForShareSheet === void 0 ? void 0 : socialMediaButtonsForShareSheet.map(function (button, index) {
    return /* @__PURE__ */React15.createElement(EGDSSpacing2, {
      margin: {
        inlineend: "six"
      },
      key: "".concat(button.primary, "-").concat(index)
    }, /* @__PURE__ */React15.createElement(SocialShareOptionButton, {
      data: button,
      title: title,
      setToastText: setToastText
    }));
  }))), /* @__PURE__ */React15.createElement(EGDSToast, {
    onDismiss: onToastDismiss,
    show: !!toastText
  }, toastText))))))), /* @__PURE__ */React15.createElement(ViewLarge2, null, /* @__PURE__ */React15.createElement(IntersectionTracker, {
    referrerId: (_shareSheetAnalytics_loadAnalytics_referrerId1 = shareSheetAnalytics === null || shareSheetAnalytics === void 0 ? void 0 : (_shareSheetAnalytics_loadAnalytics2 = shareSheetAnalytics.loadAnalytics) === null || _shareSheetAnalytics_loadAnalytics2 === void 0 ? void 0 : _shareSheetAnalytics_loadAnalytics2.referrerId) !== null && _shareSheetAnalytics_loadAnalytics_referrerId1 !== void 0 ? _shareSheetAnalytics_loadAnalytics_referrerId1 : "",
    linkName: (_shareSheetAnalytics_loadAnalytics_linkName1 = shareSheetAnalytics === null || shareSheetAnalytics === void 0 ? void 0 : (_shareSheetAnalytics_loadAnalytics3 = shareSheetAnalytics.loadAnalytics) === null || _shareSheetAnalytics_loadAnalytics3 === void 0 ? void 0 : _shareSheetAnalytics_loadAnalytics3.linkName) !== null && _shareSheetAnalytics_loadAnalytics_linkName1 !== void 0 ? _shareSheetAnalytics_loadAnalytics_linkName1 : ""
  }, /* @__PURE__ */React15.createElement(EGDSSheetTransition, {
    isVisible: showShareSheet
  }, /* @__PURE__ */React15.createElement(EGDSSheet, {
    isVisible: showShareSheet,
    type: "popover",
    triggerRef: triggerRef2,
    position: {
      inline: "leading",
      block: "trailing"
    },
    width: 440,
    closeCallback: onDismissSheet
  }, /* @__PURE__ */React15.createElement(Toolbar, {
    data: toolbarData,
    onDismissSheet: onDismissSheet
  }), /* @__PURE__ */React15.createElement(EGDSSheetContent, null, cardData && /* @__PURE__ */React15.createElement(Card, {
    data: cardData
  }), /* @__PURE__ */React15.createElement(EGDSSpacing2, {
    margin: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React15.createElement(EGDSLayoutGrid3, {
    columns: 3,
    space: {
      column: "twelve",
      row: "six"
    }
  }, socialMediaButtonsForShareSheet === null || socialMediaButtonsForShareSheet === void 0 ? void 0 : socialMediaButtonsForShareSheet.map(function (button, index) {
    return /* @__PURE__ */React15.createElement(EGDSLayoutGridItem3, {
      key: "".concat(button.primary, "-").concat(index),
      justifySelf: "center"
    }, /* @__PURE__ */React15.createElement(SocialShareOptionButton, {
      data: button,
      title: title,
      setToastText: setToastText
    }));
  }))), /* @__PURE__ */React15.createElement(EGDSToast, {
    onDismiss: onToastDismiss,
    show: !!toastText
  }, toastText)))))));
};
// src/components/social-share-custom-sheet/social-share-custom-sheet-skeleton.tsx
import React16 from "react";
import { EGDSLayoutGrid as EGDSLayoutGrid4, EGDSLayoutGridItem as EGDSLayoutGridItem4 } from "@egds/react-core/layout-grid";
import { EGDSSheet as EGDSSheet2, EGDSSheetContent as EGDSSheetContent2, EGDSSheetTransition as EGDSSheetTransition2 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing3 } from "@egds/react-core/spacing";
var CustomShareSheetSkeleton = function (param) {
  var showShareSheet = param.showShareSheet,
    toolbarData = param.toolbarData,
    triggerRef2 = param.triggerRef;
  return /* @__PURE__ */React16.createElement(EGDSSheetTransition2, {
    isVisible: showShareSheet
  }, /* @__PURE__ */React16.createElement(EGDSSheet2, {
    isVisible: showShareSheet,
    type: "popover",
    triggerRef: triggerRef2,
    position: {
      inline: "leading",
      block: "trailing"
    },
    width: 440,
    maxHeight: 700
  }, /* @__PURE__ */React16.createElement(Toolbar, {
    data: toolbarData
  }), /* @__PURE__ */React16.createElement(EGDSSheetContent2, null, /* @__PURE__ */React16.createElement(CardSkeleton, null), /* @__PURE__ */React16.createElement(EGDSSpacing3, {
    margin: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React16.createElement(EGDSLayoutGrid4, {
    columns: 3,
    space: {
      column: "twelve",
      row: "four"
    }
  }, _to_consumable_array(Array(6)).map(function (_, index) {
    return /* @__PURE__ */React16.createElement(EGDSLayoutGridItem4, {
      key: index,
      justifySelf: "center"
    }, /* @__PURE__ */React16.createElement(SocialShareOptionButtonSkeleton, null));
  }))))));
};
// src/components/social-share-error-toast/social-share-error-toast.tsx
import React17 from "react";
import { gql as gql13 } from "@apollo/client";
import { EGDSToast as EGDSToast2, TimerSetting } from "@egds/react-core/toast";
import { IntersectionTracker as IntersectionTracker2 } from "@shared-ui/clickstream-analytics-context";
var __SocialShareErrorToast = gql13(_templateObject12(), Icon.fragment);
var SocialShareErrorToast = function (param) {
  var data = param.data,
    onToastDismiss = param.onToastDismiss;
  var heading = data.heading,
    description = data.description,
    errorAnalytics = data.errorAnalytics;
  return /* @__PURE__ */React17.createElement(IntersectionTracker2, {
    trackOnce: true,
    referrerId: errorAnalytics.referrerId,
    linkName: errorAnalytics.linkName
  }, /* @__PURE__ */React17.createElement(EGDSToast2, {
    show: true,
    onDismiss: onToastDismiss,
    autoHideTimer: TimerSetting.long
  }, heading, " ", description));
};
SocialShareErrorToast.fragment = __SocialShareErrorToast;
SocialShareErrorToast.displayName = "SocialShareErrorBanner";
// src/components/social-share-button/social-share-button.tsx
var __SocialShareButtonQuery = gql14(_templateObject13(), SocialShareErrorToast.fragment, ShareButtons.fragment, Toolbar.fragment, PlainText.fragment, Card.fragment, SocialShareOptionButton.fragment);
var triggerRef = React18.createRef();
var SocialShareButton = function (param) {
  var inputs = param.inputs,
    skipSsr = param.skipSsr;
  var _shareButtonAnalytics_loadAnalytics, _shareButtonAnalytics_loadAnalytics1;
  var context = useBexApi().context;
  var analyticsTracker = useClickTracker4();
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname,
    search = _useLocation.search;
  var _React18_useState = _sliced_to_array(React18.useState(false), 2),
    showSheet = _React18_useState[0],
    setShowSheet = _React18_useState[1];
  var _React18_useState1 = _sliced_to_array(React18.useState(false), 2),
    isCustomShareSheet = _React18_useState1[0],
    setIsCustomShareSheet = _React18_useState1[1];
  var _React18_useState2 = _sliced_to_array(React18.useState(false), 2),
    isClientSideError = _React18_useState2[0],
    setIsClientSideError = _React18_useState2[1];
  var _useDialog = _sliced_to_array(useDialog("customer-notification-full-sheet-dialog"), 3),
    isDialogOpen = _useDialog[0],
    dialogActions = _useDialog[1],
    DialogComponent = _useDialog[2];
  var identity = getPageId(inputs.shareContext.pageId);
  var type = context.device.type;
  var desktopBranchSharing = useExperiment("V2_VRBO_Desktop_Branch_Sharing");
  var desktopBranchSharingEnabled = desktopBranchSharing.exposure.bucket === 1 && type === "DESKTOP" /* DESKTOP */;
  var _useLazyQuery = _sliced_to_array(useLazyQuery(__SocialShareButtonQuery, {
      ssr: !skipSsr
    }), 2),
    callQuery = _useLazyQuery[0],
    _useLazyQuery_ = _useLazyQuery[1],
    data = _useLazyQuery_.data,
    previousData = _useLazyQuery_.previousData,
    error = _useLazyQuery_.error,
    loading = _useLazyQuery_.loading;
  React18.useEffect(function () {
    callQuery({
      variables: {
        shareContext: _object_spread_props(_object_spread({}, inputs.shareContext), {
          pageId: identity.pageId,
          lineOfBusiness: identity.lineOfBusiness,
          callToDownStreamServices: false
        }),
        context: context
      }
    });
  }, []);
  React18.useEffect(function () {
    setIsClientSideError(false);
  }, [search]);
  if (!data && !previousData) {
    return null;
  }
  var _ref = (data === null || data === void 0 ? void 0 : data.socialShareSheet) || (previousData === null || previousData === void 0 ? void 0 : previousData.socialShareSheet) || {},
    shareButtonType = _ref.shareButtonType,
    shareButtonAnalytics = _ref.shareButtonAnalytics,
    title = _ref.title,
    message = _ref.message,
    toolbar = _ref.toolbar,
    shareSheetAnalytics = _ref.shareSheetAnalytics,
    serverSideErrorDialog = _ref.serverSideErrorDialog,
    clientSideErrorDialog = _ref.clientSideErrorDialog,
    imageCard = _ref.imageCard,
    socialMediaButtonsForShareSheet = _ref.socialMediaButtonsForShareSheet;
  var onClick = function () {
    if (shareButtonAnalytics === null || shareButtonAnalytics === void 0 ? void 0 : shareButtonAnalytics.clickImpressionAnalytics) {
      var _shareButtonAnalytics_clickImpressionAnalytics;
      analyticsTracker(shareButtonAnalytics === null || shareButtonAnalytics === void 0 ? void 0 : shareButtonAnalytics.clickImpressionAnalytics.referrerId, (_shareButtonAnalytics_clickImpressionAnalytics = shareButtonAnalytics.clickImpressionAnalytics) === null || _shareButtonAnalytics_clickImpressionAnalytics === void 0 ? void 0 : _shareButtonAnalytics_clickImpressionAnalytics.linkName);
    }
    if (desktopBranchSharingEnabled) {
      setIsCustomShareSheet(true);
      dialogActions.openDialog();
    }
    callQuery({
      variables: {
        shareContext: _object_spread_props(_object_spread({}, inputs.shareContext), {
          pageId: identity.pageId,
          lineOfBusiness: identity.lineOfBusiness,
          rffrURL: "".concat(pathname).concat(search),
          callToDownStreamServices: true
        }),
        context: context
      }
    });
    setShowSheet(true);
  };
  var resetShareSheetState = function () {
    setShowSheet(false);
    setIsClientSideError(false);
  };
  if (loading) {
    return /* @__PURE__ */React18.createElement(React18.Fragment, null, shareButtonType && /* @__PURE__ */React18.createElement(ShareButtons, {
      data: shareButtonType,
      onClick: onClick,
      domRef: triggerRef
    }), /* @__PURE__ */React18.createElement(Viewport7, null, /* @__PURE__ */React18.createElement(ViewSmall7, null, /* @__PURE__ */React18.createElement(UitkPageLoader, {
      visible: loading,
      "data-testid": "loading-spinner"
    })), /* @__PURE__ */React18.createElement(ViewLarge3, null, /* @__PURE__ */React18.createElement(CustomShareSheetSkeleton, {
      toolbarData: toolbar,
      showShareSheet: loading,
      triggerRef: triggerRef
    }))));
  }
  if (isClientSideError && clientSideErrorDialog && !serverSideErrorDialog || isClientSideError && clientSideErrorDialog && !toolbar) {
    return /* @__PURE__ */React18.createElement(React18.Fragment, null, shareButtonType && /* @__PURE__ */React18.createElement(ShareButtons, {
      data: shareButtonType,
      onClick: onClick,
      domRef: triggerRef
    }), /* @__PURE__ */React18.createElement(SocialShareErrorToast, {
      data: clientSideErrorDialog,
      onToastDismiss: resetShareSheetState
    }));
  }
  if (error && serverSideErrorDialog) {
    return /* @__PURE__ */React18.createElement(React18.Fragment, null, shareButtonType && /* @__PURE__ */React18.createElement(ShareButtons, {
      data: shareButtonType,
      onClick: onClick,
      domRef: triggerRef
    }), /* @__PURE__ */React18.createElement(SocialShareErrorToast, {
      data: serverSideErrorDialog,
      onToastDismiss: resetShareSheetState
    }));
  }
  return /* @__PURE__ */React18.createElement(Viewport7, null, /* @__PURE__ */React18.createElement(ViewSmall7, null, /* @__PURE__ */React18.createElement(React18.Fragment, null, shareButtonType && (shareButtonAnalytics === null || shareButtonAnalytics === void 0 ? void 0 : shareButtonAnalytics.loadAnalytics) && /* @__PURE__ */React18.createElement(IntersectionTracker3, {
    trackOnce: true,
    referrerId: shareButtonAnalytics === null || shareButtonAnalytics === void 0 ? void 0 : (_shareButtonAnalytics_loadAnalytics = shareButtonAnalytics.loadAnalytics) === null || _shareButtonAnalytics_loadAnalytics === void 0 ? void 0 : _shareButtonAnalytics_loadAnalytics.referrerId,
    linkName: shareButtonAnalytics === null || shareButtonAnalytics === void 0 ? void 0 : (_shareButtonAnalytics_loadAnalytics1 = shareButtonAnalytics.loadAnalytics) === null || _shareButtonAnalytics_loadAnalytics1 === void 0 ? void 0 : _shareButtonAnalytics_loadAnalytics1.linkName
  }, /* @__PURE__ */React18.createElement(ShareButtons, {
    data: shareButtonType,
    onClick: onClick,
    domRef: triggerRef
  })), showSheet && isCustomShareSheet && triggerRef.current && desktopBranchSharingEnabled && /* @__PURE__ */React18.createElement(CustomShareSheet, {
    cardData: imageCard,
    title: title,
    socialMediaButtonsForShareSheet: socialMediaButtonsForShareSheet,
    toolbarData: toolbar,
    triggerRef: triggerRef,
    showShareSheet: isDialogOpen,
    shareSheetAnalytics: shareSheetAnalytics,
    DialogComponent: DialogComponent,
    setIsClientSideError: setIsClientSideError,
    onDismissSheet: resetShareSheetState
  }), showSheet && !isCustomShareSheet && clientSideErrorDialog && !serverSideErrorDialog && /* @__PURE__ */React18.createElement(NativeSocialShareSheet, {
    title: title,
    message: message,
    shareSheetAnalytics: shareSheetAnalytics,
    closeAnalytics: toolbar === null || toolbar === void 0 ? void 0 : toolbar.navigation.analytics,
    onChangeState: setShowSheet,
    isClientSideError: isClientSideError,
    setIsClientSideError: setIsClientSideError
  }))));
};
SocialShareButton.displayName = "sharedui-SocialShareButton";
export { SocialShareButton };